import React from 'react';

const RoadmapStudentViewSkeleton = () => {
  return (
    <div className="animate-pulse text-white">
      {/* Header Skeleton */}
      <div className="bg-slate-800 border-b border-slate-700 p-4">
        <div className="h-8 bg-slate-700 rounded w-64 mb-2"></div> {/* Title placeholder */}
      </div>

      <div className="p-4 space-y-6 bg-slate-900">
        {/* Hero Section Skeleton */}
        <div className="relative rounded-lg bg-gradient-to-br p-6 from-purple-900 via-blue-900 to-indigo-900">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-slate-700 rounded-full"></div> {/* Avatar placeholder */}
            <div className="flex items-start flex-col">
              <div className="h-6 bg-slate-700 rounded w-48 mb-2"></div> {/* Student name placeholder */}
              <div className="h-4 bg-blue-200 rounded-full w-32"></div> {/* Progress badge placeholder */}
            </div>
          </div>

          {/* Progress Overview Skeleton */}
          <div className="mt-6">
            <div className="flex items-center justify-between mb-4">
              <div className="h-6 bg-slate-700 rounded w-56"></div> {/* Journey Progress title */}
              <div className="text-right">
                <div className="h-8 bg-slate-700 rounded w-20 mb-1"></div> {/* Global progress % */}
                <div className="h-4 bg-slate-700 rounded w-40"></div> {/* Levels completed text */}
              </div>
            </div>

            {/* Level Progress Cards Skeleton */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {[...Array(3)].map((_, i) => ( // 3 level card placeholders
                <div key={i} className="bg-slate-800/50 rounded-xl p-4 border border-white/10">
                  <div className="flex space-x-3 mb-3">
                    <div className="w-8 h-8 bg-slate-700 rounded-full"></div> {/* Level icon */}
                    <div>
                      <div className="h-5 bg-slate-700 rounded w-24 mb-1"></div> {/* Level name */}
                      <div className="h-4 bg-slate-700 rounded w-32"></div> {/* Level subtitle */}
                    </div>
                  </div>
                  <div className="mb-3">
                    <div className="flex justify-between text-xs text-slate-300 mb-1">
                      <div className="h-3 bg-slate-700 rounded w-20"></div> {/* Completed text */}
                      <div className="h-3 bg-slate-700 rounded w-10"></div> {/* Progress % */}
                    </div>
                    <div className="w-full bg-gray-600 rounded-full h-2">
                      <div className="bg-slate-700 h-2 rounded-full w-2/3"></div> {/* Progress bar */}
                    </div>
                  </div>
                  <div className="h-10 bg-slate-700 rounded w-full"></div> {/* Description placeholder */}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Levels Content Section Skeleton */}
        <div className="space-y-8">
          {[...Array(2)].map((_, levelIndex) => ( // 2 full level content placeholders
            <div key={levelIndex}>
              {/* Level Header Skeleton */}
              <div className="flex justify-between mb-6">
                <div className="flex items-center space-x-4">
                  <div className="w-10 h-10 bg-slate-700 rounded-full"></div> {/* Level order icon */}
                  <div>
                    <div className="h-6 bg-slate-700 rounded w-32 mb-1"></div> {/* Level name */}
                    <div className="h-4 bg-slate-700 rounded w-24"></div> {/* Level subtitle */}
                  </div>
                </div>
                <div className="text-right">
                  <div className="h-6 bg-slate-700 rounded w-16 mb-1"></div> {/* Items completed count */}
                  <div className="h-4 bg-slate-700 rounded w-28"></div> {/* Items completed text */}
                </div>
              </div>

              {/* Items Grid Skeleton */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {[...Array(4)].map((_, itemIndex) => ( // 4 item card placeholders per level
                  <div key={`${levelIndex}-${itemIndex}`} className="p-4 rounded-xl border border-slate-700 bg-slate-800/50">
                    <div className="flex items-start justify-between mb-3">
                      <div className="h-5 bg-slate-700 rounded w-20"></div> {/* Status badge */}
                      <div className="h-4 bg-slate-700 rounded w-8"></div> {/* Order number */}
                    </div>
                    <div className="h-5 bg-slate-700 rounded w-3/4 mb-2"></div> {/* Title */}
                    <div className="h-12 bg-slate-700 rounded w-full mb-3"></div> {/* Description */}
                    <div className="flex items-center space-x-8 text-slate-400 text-sm mb-2">
                      <div className="h-4 bg-slate-700 rounded w-20"></div> {/* Due date */}
                      <div className="h-4 bg-slate-700 rounded w-24"></div> {/* Estimated hours */}
                    </div>
                    <div className="mt-2 flex items-center justify-start">
                      <div className="h-4 bg-slate-700 rounded w-28"></div> {/* Resources count */}
                    </div>
                    <div className="mt-3 pt-3 border-t border-slate-600">
                        <div className="flex items-center justify-between">
                            <div className="h-4 bg-slate-700 rounded w-20"></div> {/* My Rating text */}
                            <div className="h-4 bg-slate-700 rounded w-16"></div> {/* Add Review/Edit Review button */}
                        </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoadmapStudentViewSkeleton;
